import React, { useRef, useState } from "react";
import "./Header.css";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";

function Header() {
  const navbarToggleRef = useRef(null);

  const [activeItem, setActiveItem] = useState();

  const [setups, setSetup] = useState();

  const handleNavItemClick = (id) => {
    if (navbarToggleRef.current && window.innerWidth <= 992) {
      navbarToggleRef.current.click();
    }
  };

  const handleNavItemClick2 = (link) => {
    navigate(link);
    if (navbarToggleRef.current && window.innerWidth <= 992) {
      navbarToggleRef.current.click();
    }
  };

  const loanCal = [
    {
      baseLink: "/loan-calculator",
      label: "EMI Calculator",
      link: "loan-calculator",
    },
    {
      baseLink: "/eligibilty-calculator",
      label: "Eligibility Calculator",
      link: "loan-calculator",
    },
  ];

  const navigate = useNavigate()

  const scrollToSection = (id, offset = 100) => {
    const section = document.getElementById(id);
    if (section) {
      const top = section.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <>
      <section className="header_section">
        <div className="container">
          <Navbar expand="lg">
            <Navbar.Brand onClick={() => { navigate("/") }}>
              <img
                className="headlogo"
                src="\assets\Image\Header\header_logo.png"
                alt="Logo"
              />
            </Navbar.Brand>
            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              ref={navbarToggleRef}
            />

            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ms-auto">

                <Nav.Link
                  as={Link}
                  to="tel:8956368061"
                  target="_blank" className="phone_link_holder"
                >
                  <FontAwesomeIcon icon={faPhone} /> 8956368061
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/"
                  active={activeItem === "home"}
                  onClick={() => {
                    scrollToSection("our_service")
                    handleNavItemClick()
                  }}
                >
                  Loans
                </Nav.Link>
                {/* <Nav.Link
                  as={Link}
                  to="/"
                  active={activeItem === "near-me"}
                  onClick={() => {
                    scrollToSection("Insurance")
                    handleNavItemClick()
                  }}
                >
                  Insurance
                </Nav.Link> */}
                <NavDropdown
                  title="Loan Calculator"
                  id="basic-nav-dropdown"
                  className="me-3"
                >
                  {loanCal?.map((value) => {
                    return (
                      <div className="nav_holder">
                        <NavDropdown.Item key={value?.label} onClick={() => scrollToSection("calculate_loan")}>
                          {value?.label}
                        </NavDropdown.Item>
                      </div>
                    );
                  })}
                </NavDropdown>
                {/* <Nav.Link
                  as={Link}
                  to="/"
                  active={activeItem === "near-me"}
                  onClick={handleNavItemClick}
                >
                  Become a Partner
                </Nav.Link> */}
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </div>
      </section>
    </>
  );
}

export default Header;
